import { Api } from '../api/root-api';
import {
  FetchEventRequest,
  FetchEventResponse,
  MixpanelEventResponse,
  MixpanelEvnetRequest,
  MixpanelTrackUserRequest,
  MixpanelTrackUserResponse,
  UpsertEventRequest,
  UpsertEventResponse,
} from './model';
import { updateJTBDDataFromFirebase } from './slice';

export const JTBDApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchEvents: builder.mutation<FetchEventResponse, FetchEventRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/mixpanel/get-workspace-events`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        queryFulfilled.then((response) => {
          const events = response.data?.map((item) => item.event);
          dispatch(
            updateJTBDDataFromFirebase(
              (getState() as any)?.jtbd?.jtbdDataFromFirebase.map((tour) => ({
                ...tour,
                groups: tour.groups.map((group) => ({
                  ...group,
                  items: group.items.map((item) => ({
                    ...item,
                    isCompleted: events.includes(item.event),
                  })),
                })),
              }))
            )
          );
        });
      },
    }),
    mixpanelEvent: builder.mutation<
      MixpanelEventResponse,
      MixpanelEvnetRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/mixpanel/event`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    mixpanelTrackUser: builder.mutation<
      MixpanelTrackUserResponse,
      MixpanelTrackUserRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/mixpanel/track-user`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    upsertEvent: builder.mutation<UpsertEventResponse, UpsertEventRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/mixpanel/workspace-event`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        queryFulfilled.then((response) => {
          dispatch(
            JTBDApi.endpoints.fetchEvents.initiate({
              params: request.params,
              body: {
                events: (getState() as any)?.jtbd?.jtbdEvents ?? [],
              },
            })
          );
        });
      },
    }),
  }),
});

export const {
  useFetchEventsMutation,
  useMixpanelEventMutation,
  useMixpanelTrackUserMutation,
  useUpsertEventMutation,
} = JTBDApi;
